import { Fetch } from '../../shared/types';

type ResponseData = { success: boolean; errors?: unknown };

/**
 * Test the Authentication against it's API to make sure
 * it has been set up correctly and is still valid.
 * https://zapier.com/api/v4/redoc/#operation/api_v4_authentications_call
 */
const testAuthentication = (fetch: Fetch, id: number) => {
  return fetch<ResponseData>(`/api/v4/authentications/${id}/test/`, {
    method: 'POST',
  }).then(({ success }) => !!success);
};

export default testAuthentication;
